import React from 'react';


const tecno = [
    { T: 'Oracle', L: 'https://www.mysql.com/' },




];


class Cinegonbi extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">






                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>Cinegon data base</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <div className="imageProyect imageCinegon"></div>

                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>This database in Oracle belongs to the Cinegon application.</p>

                        <a href="https://github.com/BrandonGrimaldoM/CinegonDataBase" target="_blank" rel="noreferrer">
                            <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Cinegonbi;